import accountForm from '@/lang/views/accountSetting/AccountForm-th'
import attendanceSummaryList from '@/lang/components/dashboard/AttendanceSummaryList-th'
import employeeStatusGraph from '@/lang/components/dashboard/EmployeeStatusGraph-th'
import averageCheckInGraph from '@/lang/components/dashboard/AverageCheckInGraph-th'
import onsiteTodayTable from '@/lang/components/dashboard/OnsiteTodayTable-th'
import blacklist from '@/lang/views/blacklist/Blacklist-th'
import blacklistForm from '@/lang/views/blacklist/BlacklistForm-th'
import bureau from './components/companySetting/Bureau-th'
import companyProfile from '@/lang/components/companySetting/CompanyProfile-th'
import companySetting from '@/lang/views/companySetting/CompanySetting-th'
import dashboard from '@/lang/views/dashboard/Dashboard-th'
import deleteModal from '@/lang/components/modal/DeleteModal-th'
import deviceManagement from '@/lang/views/deviceManagement/DeviceManagement-th'
import employee from '@/lang/views/employee/Employee-th'
import errorModal from '@/lang/components/modal/ErrorModal-th'
import logoutModal from '@/lang/components/modal/LogoutModal-th'
import positions from '@/lang/views/companySetting/Positions-th'
import sidebar from '@/lang/components/Sidebar-th'
import specialWorkday from '@/lang/components/timeTableSetting/SpecialWorkday-th'
import specialWorkdayFormModal from './components/timeTableSetting/SpecialWorkdayFormModal-th'
import { th } from 'vuetify/lib/locale'
import timeTableSetting from './views/timeTableSetting/TimeTableSetting-th'
import toggleStatus from '@/lang/components/ToggleStatus-th'
import userForm from '@/lang/views/UserForm-th'
import userManagement from '@/lang/components/companySetting/UserManagement-th'
import lineService from '@/lang/components/companySetting/LineService-th'
import assignDeviceModal from '@/lang/components/deviceManagement/AssignDeviceModal-th'
import workday from '@/lang/components/timeTableSetting/Workday-th'
import workdayForm from '@/lang/components/timeTableSetting/WorkdayForm-th'
import employeeImport from '@/lang/views/employee/EmployeeImport-th'
import employeeImportImage from '@/lang/components/employee/EmployeeImportImage-th'
import employeeImportList from '@/lang/components/employee/EmployeeImportList-th'
import importEmployeesFormModal from '@/lang/components/modal/ImportEmployeesFormModal-th'
import lineRegister from '@/lang/views/liff/LineRegister-th'
import checkInOnsite from '@/lang/views/liff/CheckInOnsite-th'
import holiday from '@/lang/components/timeTableSetting/Holiday-th'
import holidayFormModal from './components/timeTableSetting/HolidayFormModal-th'
import activityLog from '@/lang/views/activityLog/ActivityLog-th'
import punchLog from '@/lang/views/punchLog/PunchLog-th'
import inquiry from '@/lang/components/inquiryAndAttendance/Inquiry-th'
import inquiryForm from '@/lang/components/inquiryAndAttendance/InquiryForm-th'
import statusAttendance from '@/lang/components/inquiryAndAttendance/StatusAttendance-th'
import statusAttendanceForm from '@/lang/components/inquiryAndAttendance/StatusAttendanceForm-th'
import manageAttendance from '@/lang/components/inquiryAndAttendance/ManageAttendance-th'
import manageAttendanceForm from '@/lang/components/inquiryAndAttendance/ManageAttendanceForm-th'
import punchLogAttendance from '@/lang/components/inquiryAndAttendance/PunchLog-th'
import visitorActivity from '@/lang/components/visitor/VisitorActivity-th'
import visitorList from '@/lang/components/visitor/VisitorList-th'
import login from '@/lang/views/authentication/Login-th'
import forgotPassword from '@/lang/views/authentication/ForgotPassword-th'
import resetPassword from '@/lang/views/authentication/ResetPassword-th'
import resetPasswordExpired from '@/lang/views/authentication/ResetPasswordExpired-th'

// line liff
import leaveRequest from '@/lang/views/liff/modules/Inquiry/LeaveRequest-th'
import InquiryOverview from '@/lang/views/liff/modules/Inquiry/Overview-th'
import InquiryBureau from '@/lang/views/liff/modules/Inquiry/Bureau-th'
import VisitorCreate from '@/lang/views/liff/modules/Visitor/VisitorCreate-th'
import AttendanceBureau from '@/lang/views/liff/modules/History/AttendanceBureau-th'
import AttendanceOverviewDetail from '@/lang/views/liff/modules/History/AttendanceOverviewDetail-th'
import AttendanceOverview from '@/lang/views/liff/modules/History/AttendanceOverview-th'
import HistoryAttendance from '@/lang/views/liff/modules/History/HistoryAttendance-th'
import HistoryOnsite from '@/lang/views/liff/modules/History/HistoryOnsite-th'
import HistoryQuota from '@/lang/views/liff/modules/History/HistoryQuota-th'
import PunchLogSecurity from '@/lang/views/liff/modules/Security/PunchLogSecurity-th'
import PunchLogSecurityDetail from '@/lang/views/liff/modules/Security/PunchLogSecurityDetail-th'
import DatepickerCustom from '@/lang/views/liff/modules/DatePicker/DatepickerCustom-th'
import visitor from '@/lang/views/visitor/visitor-th'
import visitorInfo from '@/lang/views/visitor/visitorInfo-th'
import visitorForm from '@/lang/components/visitor/VisitorForm-th'
// // end line liff
import uploadimage from '@/lang/components/UploadImage-th'

export default {
    ...th,
    login,
    attendanceSummaryList,
    employeeStatusGraph,
    averageCheckInGraph,
    onsiteTodayTable,
    bureau,
    blacklistForm,
    deleteModal,
    errorModal,
    userForm,
    sidebar,
    dashboard,
    logoutModal,
    companyProfile,
    companySetting,
    specialWorkday,
    specialWorkdayFormModal,
    timeTableSetting,
    toggleStatus,
    userManagement,
    blacklist,
    accountForm,
    positions,
    employee,
    deviceManagement,
    workday,
    workdayForm,
    employeeImport,
    employeeImportImage,
    employeeImportList,
    importEmployeesFormModal,
    assignDeviceModal,
    lineRegister,
    checkInOnsite,
    holiday,
    holidayFormModal,
    lineService,
    visitor,
    visitorInfo,
    visitorForm,
    // line liff
    leaveRequest,
    InquiryOverview,
    InquiryBureau,
    VisitorCreate,
    AttendanceBureau,
    AttendanceOverviewDetail,
    AttendanceOverview,
    HistoryAttendance,
    HistoryOnsite,
    HistoryQuota,
    PunchLogSecurity,
    PunchLogSecurityDetail,
    activityLog,
    punchLog,
    inquiry,
    inquiryForm,
    statusAttendance,
    statusAttendanceForm,
    manageAttendance,
    manageAttendanceForm,
    punchLogAttendance,
    visitorActivity,
    visitorList,
    forgotPassword,
    resetPassword,
    resetPasswordExpired,
    DatepickerCustom,
    uploadimage
}
